import React from 'react';
import { useSetAtom } from 'jotai';

import ProgressSpinner from '@smart-tv/components/progress-spinner';
import styles from './player-loading.module.scss';
import { isSkippingAtom } from '../player-controls/player-controls-navigation/skip-buttons';

interface Props {
  playerWaiting: boolean;
}

export const PlayerLoadingSpinner: React.FC<Props> = (props: Props) => {
  const { playerWaiting } = props;
  const setIsSkipping = useSetAtom(isSkippingAtom);

  React.useEffect(() => {
    return () => {
      setIsSkipping(false);
    };
  }, [setIsSkipping]);

  if (!playerWaiting) return null;

  return (
    <div className={styles['player-loading__spinner']}>
      <ProgressSpinner />
    </div>
  );
};

export default React.memo(PlayerLoadingSpinner);
